/**
 * @file Skeleton 骨架屏
 * @description 加载占位块。
 *
 * @whenToUse 列表/卡片内容加载中的占位。
 * @whenNotToUse 简单转圈（用 Spinner）。
 */

import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/cn.ts'

export type SkeletonProps = HTMLAttributes<HTMLDivElement>

export function Skeleton({ className, ...rest }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-border/60',
        className,
      )}
      {...rest}
    />
  )
}
